
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyErrorText',
  props: {
    text: {
      type: String,
      default: undefined,
    },
  },
});
